
// pgw 01-may-2026 - testing edit lyrics and chapters
import { applyMetadataOverrideToSong } from "./metadataOverrides";

// pgw 09-feb-2026
let doprint = false;
// let doprint = true;


// pgw 20-apr-2026 - testing CG integration

export function isCgTestingEnabled() {
  try {
    return window.localStorage.getItem("cgTesting") === "1";
  } catch (e) {
    return false;
  }
}

export function getCgSonglistUrl(defaultUrl) {
  if (doprint) console.log('getCgSonglistUrl p1 defaultUrl = ', defaultUrl);
  if (doprint) console.log('getCgSonglistUrl p2 isCgTestingEnabled() = ', isCgTestingEnabled());

  if (!isCgTestingEnabled()) return defaultUrl;

  const res = "https://sessionplayer.s3.amazonaws.com/song_list_choir_genius.json";

  if (doprint) console.log('getCgSonglistUrl p3 returning res = ', res);

  return res;
}

export function getChoirGeniusSetlistsApiUrl() {
  return "https://choirplayer.choirgenius.com/mobile-api/music_sets";
}

export function getCgAuthToken() {
  if (!isCgTestingEnabled()) {
    return typeof AUTH_TOKEN !== "undefined" ? AUTH_TOKEN : "";
  }

  try {
    const token =
      window.localStorage.getItem("AUTH_TOKEN") ||
      window.localStorage.getItem("authToken") ||
      "";

    if (doprint) console.log("getCgAuthToken cgTesting token found =", !!token);

    if (!token) {
      console.warn("cgTesting is enabled but no AUTH_TOKEN was found in localStorage");
    }

    return token;
  } catch (e) {
    console.warn("cgTesting is enabled but AUTH_TOKEN is empty / null");
    return "";
  }
}

export function doesCgAuthTokenExist() {
	let res = false;
	if (window.localStorage.getItem("AUTH_TOKEN") || window.localStorage.getItem("authToken")) {
		res = true;
	}
	if (doprint) console.log("doesCgAuthTokenExist = ", res)
	return res;
}

export function getCgAuthHeaders() {
  const token = getCgAuthToken();

if (doprint) console.log('token = ', token);

  return {
    "X-Auth-Token": token,
    Accept: "application/json",
  };
}

export function normaliseChoirGeniusSetlist(apiSetlist) {
  return {
    id: String(apiSetlist.setlist_id ?? apiSetlist.id ?? apiSetlist.setlistId ?? cryptoRandomFallback()),
    cgSetlistId: String(apiSetlist.setlist_id ?? ""),
    title: apiSetlist.title ?? apiSetlist.name ?? "Untitled setlist",
    subTitle: apiSetlist.notes ?? apiSetlist.subTitle ?? apiSetlist.subtitle ?? "",
    imageUrl:
      apiSetlist.imageUrl ??
      apiSetlist.image_url ??
      "https://s3.eu-west-1.amazonaws.com/uploads.choirplayer.com/9758650",
    createdAt: apiSetlist.createdAt ?? new Date().toISOString(),
    lastUpdatedAt: apiSetlist.lastUpdatedAt ?? new Date().toISOString(),
    cached: false,
    items: Array.isArray(apiSetlist.items) ? apiSetlist.items : [],
    readOnly: true,
  };
}

function cryptoRandomFallback() {
  return Math.random().toString(36).slice(2, 10);
}

export async function fetchCgSetlistContents(cgSetlistId, forceFresh = false) {
  const cacheBuster = forceFresh ? `&_=${Date.now()}` : "";
  const url = `https://choirplayer.choirgenius.com/mobile-api/music?setlist_id=${encodeURIComponent(cgSetlistId)}${cacheBuster}`;

  const response = await fetch(url, {
    method: "GET",
    headers: getCgAuthHeaders(),
    cache: "no-store",
  });

  if (!response.ok) {
    throw new Error(`CG setlist contents failed: ${response.status}`);
  }

  return response.json();
}



function decodeHtml(html) {
  if (!html) return "";
  const el = document.createElement("textarea");
  el.innerHTML = html;
  return el.value.replace(/<[^>]*>/g, "").trim();
}

function chooseMainAudioFile(filesObj) {
  const files = Object.values(filesObj || {});
  if (!files.length) return null;

  const preferred =
    files.find((f) => (f.description || "").toLowerCase() === "bt") ||
    files.find((f) => (f.filename || "").toLowerCase().includes("bt")) ||
    files.find((f) => f.filemime && f.filemime.startsWith("audio/"));

  return preferred || null;
}



function getCgAudioFiles(filesObj) {
  return Object.values(filesObj || {})
    .filter((f) => f.filemime && f.filemime.startsWith("audio/") && f.url)
    .sort((a, b) => Number(a.delta || 0) - Number(b.delta || 0));
}

function buildStemsFromFiles(filesObj) {
  return getCgAudioFiles(filesObj).map((file, idx) => ({
    id: file.description || file.filename || `Stem ${idx + 1}`,
    index: idx,
    label: file.description || file.filename || `Stem ${idx + 1}`,
    level: 1,
    muted: false,
    soloed: false,
    pan: 0.5,
  }));
}

function buildTracksFromFiles(filesObj) {
  return getCgAudioFiles(filesObj).map((file) => ({
    name: file.url,
  }));
}

function buildTrackNamesFromFiles(filesObj) {
  return getCgAudioFiles(filesObj).map((file, idx) => ({
    name: file.description || file.filename || `Stem ${idx + 1}`,
  }));
}


function tryMatchSongFromLibrary(cgSong, librarySongs) {
  const visibleId = String(cgSong.visible_id || "").trim();
  const title = String(cgSong.title || "").trim().toLowerCase();

  let matched = null;

  if (visibleId) {
    matched = librarySongs.find((song) => {
      const songVisibleId = String(song.visible_id || song.visibleId || "").trim();
      return songVisibleId && songVisibleId === visibleId;
    });
  }

  if (!matched && title) {
    matched = librarySongs.find((song) => {
      const mix = String(song.mix || "").trim().toLowerCase();
      return mix === title;
    });
  }

  return matched || null;
}



function getCgFiles(filesObj) {
  return Object.values(filesObj || {}).filter((f) => f.url);
}

function fileMatches(file, words) {
  const haystack = [
    file.filename,
    file.description,
    file.uri,
    file.url,
  ].join(" ").toLowerCase();

  return words.some((word) => haystack.includes(word));
}

export function getCgLyricsFileUrl(cgSong) {
  const file = getCgFiles(cgSong.files).find((f) =>
    fileMatches(f, ["lyrics"])
  );

  return file?.url || "";
}

export function getCgChaptersFileUrl(cgSong) {
  const file = getCgFiles(cgSong.files).find((f) =>
    fileMatches(f, ["chapters", "sections"])
  );

  return file?.url || "";
}

export async function fetchCgTextFile(url) {

	if (doprint) console.log('fetchCgTextFile url = ', url);

  if (!url) return "";

  const response = await fetch(url, {
    method: "GET",
    headers: getCgAuthHeaders(),
  });

	if (doprint) console.log('fetchCgTextFile response.ok = ', response.ok);


  if (!response.ok) {
    throw new Error(`CG text file fetch failed: ${response.status}`);
  }
  return response.text();
}

function parseTimeToSeconds(value) {
  if (value === undefined || value === null) return 0;

  const text = String(value).trim();

  if (/^\d+(\.\d+)?$/.test(text)) {
    return Number(text);
  }

  const parts = text.split(":").map(Number);

  if (parts.length === 3) {
    return (parts[0] * 3600) + (parts[1] * 60) + parts[2];
  }

  if (parts.length === 2) {
    return (parts[0] * 60) + parts[1];
  }

  return 0;
}


export function parseCgChaptersText(text) {

  if (doprint) console.log("parseCgChaptersText text = ", text);

  if (!text) return [];

  if (doprint) console.log("parseCgChaptersText raw text =", text);


  try {
    const xml = new DOMParser().parseFromString(text, "text/xml");

    const parseError = xml.querySelector("parsererror");
    if (parseError) {
      console.warn("CG chapters XML parse error", parseError.textContent);
      return [];
    }


	const nodes = Array.from(xml.querySelectorAll("chapter"));
    // const nodes = Array.from(xml.querySelectorAll("chapter, chapters"));

    if (!nodes.length) {
      console.warn("No <chapter> elements found in XML");
      return [];
    }

    const chapters = nodes.map((node, index) => {
      const name =
        node.getAttribute("name") ||
        `Section ${index + 1}`;

      const time =
        node.getAttribute("time");

      return {
        name,
        time: parseTimeToSeconds(time),
      };
    });

    if (doprint) console.log("Parsed CG chapters =", chapters);

    return chapters;
  } catch (e) {
    console.warn("CG chapters parse failed", e);
    return [];
  }
}





export function mapCgMusicItemToLibrarySong(cgSong, librarySongs, cgExtras = {}) {
  const matchedLibrarySong = tryMatchSongFromLibrary(cgSong, librarySongs || []);
  const stems = buildStemsFromFiles(cgSong.files);
  const tracks = buildTracksFromFiles(cgSong.files);
  const tracknames = buildTrackNamesFromFiles(cgSong.files);

  const baseSong = matchedLibrarySong || {};
  const cgTitle = String(cgSong.title || "").trim();
  const cgDuration = Number(cgSong.duration || 0);

  // pgw 01-may-2026 - testing edit lyrics and chapters
  const mappedSong = {
    ...baseSong,

    songId: `cg-music-${cgSong.music_id}`,
    mix: cgTitle || baseSong.mix || "Untitled",
    title: cgTitle || baseSong.title || baseSong.mix || "Untitled",
    artist: baseSong.artist || "ChoirGenius",
    len: cgDuration || Number(baseSong.len || 0),
    duration: cgDuration || Number(baseSong.duration || baseSong.len || 0),
    key: cgSong.starting_key || baseSong.key || "",

    decade: baseSong.decade || "",
    genre: baseSong.genre || "",

    // IMPORTANT:
    // ChoirGenius gives direct MP3 files, not a ZIP.
    // Leave pathzip empty so sessionAPI uses the individual tracks branch.
    pathzip: "",


    tracks,
    tracknames,
    stems,

    chapters: cgExtras.chapters || [],
    lyricsUrl: cgExtras.lyricsUrl || "",
    cgChaptersUrl: cgExtras.chaptersUrl || "",
    cgChaptersCount: (cgExtras.chapters || []).length,

    cgMusicId: cgSong.music_id,

    cgVisibleId: cgSong.visible_id,
    notesHtml: cgSong.notes || "",
    notesText: decodeHtml(cgSong.notes || ""),
  };

  // pgw 01-may-2026 - testing edit lyrics and chapters
  if (cgExtras.skipMetadataOverride) {
	return mappedSong;
  }

  return applyMetadataOverrideToSong(mappedSong);

}


